import moment from 'moment';

// =============================================================================
// DATE RANGE PRESETS (Issue #10553)
// =============================================================================

export const ANALYTICS_DATE_PRESETS = {
  Today: () => [moment().startOf('day'), moment().endOf('day')],
  Yesterday: () => [
    moment().subtract(1, 'day').startOf('day'),
    moment().subtract(1, 'day').endOf('day'),
  ],
  'Last Week': () => [
    moment().subtract(1, 'week').startOf('isoWeek'),
    moment().subtract(1, 'week').endOf('isoWeek'),
  ],
  'Last Month': () => [
    moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  'This Month': () => [moment().startOf('month'), moment().endOf('day')],
  'Year to Date': () => [moment().startOf('year'), moment().endOf('day')],
  'Last Year': () => [
    moment().subtract(1, 'year').startOf('year'),
    moment().subtract(1, 'year').endOf('year'),
  ],
  'Last 7 Days': () => [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
  'Last 14 Days': () => [moment().subtract(14, 'days').startOf('day'), moment().endOf('day')],
  'Last 30 Days': () => [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')],
  'Last 90 Days': () => [moment().subtract(90, 'days').startOf('day'), moment().endOf('day')],
  'Last 180 Days': () => [moment().subtract(180, 'days').startOf('day'), moment().endOf('day')],
  'All Time': () => [moment('2020-01-01'), moment().endOf('day')],
};

export const DEFAULT_DATE_PRESET = 'Last 30 Days';

// =============================================================================
// CHART COLORS
// =============================================================================

export const CHART_COLORS = [
  '#3b82f6', // blue
  '#22c55e', // green
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // purple
  '#06b6d4', // cyan
  '#f97316', // orange
  '#ec4899', // pink
  '#14b8a6', // teal
  '#6366f1', // indigo
  '#84cc16', // lime
  '#a855f7', // violet
  '#0ea5e9', // sky
  '#e11d48', // rose
  '#eab308', // yellow
];

export const STATUS_CHART_COLORS = {
  NOT_STARTED: '#94a3b8',
  TRIAGED: '#64748b',
  READY: '#f59e0b',
  IN_PROGRESS: '#3b82f6',
  BLOCKED: '#dc2626',
  DEPENDENCY: '#db2777',
  ON_HOLD: '#8b5cf6',
  COMPLETED: '#22c55e',
  MONITORING: '#06b6d4',
  DUPLICATE: '#9ca3af',
  INPUT_REQUIRED: '#f97316',
  NO_LONGER_NEEDED: '#d1d5db',
};

export const STATUS_LABELS = {
  NOT_STARTED: 'Not Started',
  TRIAGED: 'Triaged',
  READY: 'Ready for Review',
  IN_PROGRESS: 'In Progress',
  BLOCKED: 'Blocked',
  DEPENDENCY: 'Dependency',
  ON_HOLD: 'On Hold',
  COMPLETED: 'Completed',
  MONITORING: 'Monitoring',
  DUPLICATE: 'Duplicate',
  INPUT_REQUIRED: 'Input Required',
  NO_LONGER_NEEDED: 'No Longer Needed',
};

export const OPEN_STATUSES = [
  'NOT_STARTED',
  'TRIAGED',
  'READY',
  'IN_PROGRESS',
  'BLOCKED',
  'DEPENDENCY',
  'ON_HOLD',
  'INPUT_REQUIRED',
  'MONITORING',
];

export const CLOSED_STATUSES = ['COMPLETED', 'DUPLICATE', 'NO_LONGER_NEEDED'];

// =============================================================================
// METRIC CARD KEYS
// =============================================================================

export const METRIC_KEYS = {
  TOTAL: 'total',
  OPEN: 'open',
  COMPLETED: 'completed',
  OVERDUE: 'overdue',
};
